import React from 'react';
import styled from 'styled-components';
import Box from '../components/Box/Box.js';
import Text from '../components/Text/Text.js';
import ProductCategoryIcon from '../components/GettingStartedPage/ProductCategoryIcon.js';
import Spacer from '../components/Spacer/Spacer.js';
import { get } from '../constants.js';

// Grid item
//
const FeatureCopyBlock = ({
  category,
  title,
  variant,
  children
}) => {
  console.warn('FeatureCopyBlock is deprecated. Use the v1.1 layout for Getting Started screens instead. See: https://www.fuegokit.design/react-storybook/?path=/story/patterns-getting-started-page--getting-started-page-growth');
  let Component;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (variant === 'columnWithIcon' || undefined) {
    Component = ThreeColumnBlock;
  } else if (variant === 'rowWithIcon') {
    Component = TwoColumnBlock;
  } else if (variant === 'rowWithCheckMark') {
    Component = FourColumnBlock;
  } else {
    throw new Error(`Unrecognized Feature Grid block variant ${variant}. Please specify a rendering variant of type 'columnWithIcon', 'rowWithIcon', or 'rowWithCheckMark' using the variant prop.`);
  }
  return /*#__PURE__*/React.createElement(Component, {
    category: category,
    title: title
  }, children);
};
FeatureCopyBlock.displayName = "FeatureCopyBlock";
const FourColumnBlock = ({
  category,
  title,
  children
}) => {
  return /*#__PURE__*/React.createElement(FourColItemWrapper, null, /*#__PURE__*/React.createElement(Box, {
    as: "dt"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      backgroundColor: 'elevation.surface.default.[default]',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: 'fit-content',
      color: 'icon.success'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.5L9.498 16.5L5.5 12.504",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    sx: {
      color: 'text.default',
      fontWeight: 'bold',
      fontSize: 3,
      ml: 5
    }
  }, title))), /*#__PURE__*/React.createElement(FourColumnItemText, {
    as: "dd",
    sx: {
      color: 'text.subtle',
      lineHeight: 'default',
      ml: 5,
      mt: 2
    }
  }, children));
};
FourColumnBlock.displayName = "FourColumnBlock";
const ThreeColumnBlock = ({
  category,
  title,
  children
}) => {
  return /*#__PURE__*/React.createElement(ThreeColItemWrapper, null, /*#__PURE__*/React.createElement(Box, {
    as: "dt"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      p: '6px',
      borderRadius: 3,
      backgroundColor: 'background.neutral.bold.default',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: 'fit-content'
    }
  }, category === 'workflowAutomation' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'workflowAutomationOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'adminTools' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'adminToolsOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'agile' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'agileOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'biReporting' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'biReportingOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'developerTools' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'developerToolsOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'documentManagement' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'documentManagementOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'itsm' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'itsmOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'portfolioManagement' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'portfolioManagementOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) :
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  category === 'publishing' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'publishingOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : null), title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: 12,
    axis: `vertical`
  }), /*#__PURE__*/React.createElement(Text, {
    sx: {
      color: 'text.default',
      fontWeight: 'semibold',
      fontSize: 4
    }
  }, title))), /*#__PURE__*/React.createElement(ThreeColumnItemText, {
    as: "dd",
    sx: {
      color: 'text.subtle',
      lineHeight: 'default',
      mt: 3
    }
  }, children));
};
ThreeColumnBlock.displayName = "ThreeColumnBlock";
const TwoColumnBlock = ({
  category,
  title,
  children
}) => {
  return /*#__PURE__*/React.createElement(TwoColItemWrapper, null, /*#__PURE__*/React.createElement(Box, {
    as: "dt"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      p: '6px',
      borderRadius: 3,
      backgroundColor: 'background.neutral.bold.default',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: 'fit-content'
    }
  }, category === 'workflowAutomation' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'workflowAutomationOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'adminTools' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'adminToolsOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'agile' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'agileOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'biReporting' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'biReportingOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'developerTools' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'developerToolsOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'documentManagement' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'documentManagementOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'itsm' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'itsmOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : category === 'portfolioManagement' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'portfolioManagementOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) :
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  category === 'publishing' ? /*#__PURE__*/React.createElement(ProductCategoryIcon, {
    icon: 'publishingOutline',
    size: `sm`,
    sx: {
      color: 'icon.inverse'
    }
  }) : null), title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    sx: {
      color: 'text.default',
      fontWeight: 'bold',
      fontSize: 3,
      ml: 7
    }
  }, title))), /*#__PURE__*/React.createElement(TwoColumnItemText, {
    as: "dd",
    sx: {
      color: 'text.subtle',
      lineHeight: 'default',
      ml: 7,
      mt: 2
    }
  }, children));
};
TwoColumnBlock.displayName = "TwoColumnBlock";
const FourColumnItemText = styled(Text).withConfig({
  displayName: "FeatureCopyGrid__FourColumnItemText",
  componentId: "sc-mtaumj-0"
})(["max-width:70ch;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){max-width:48ch;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const TwoColumnItemText = styled(Text).withConfig({
  displayName: "FeatureCopyGrid__TwoColumnItemText",
  componentId: "sc-mtaumj-1"
})(["max-width:70ch;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){max-width:48ch;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const ThreeColumnItemText = styled(Text).withConfig({
  displayName: "FeatureCopyGrid__ThreeColumnItemText",
  componentId: "sc-mtaumj-2"
})(["max-width:50ch;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){max-width:30ch;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const FourColItemWrapper = styled(Box).withConfig({
  displayName: "FeatureCopyGrid__FourColItemWrapper",
  componentId: "sc-mtaumj-3"
})(["min-height:revert;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){min-height:84px;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const ThreeColItemWrapper = styled(Box).withConfig({
  displayName: "FeatureCopyGrid__ThreeColItemWrapper",
  componentId: "sc-mtaumj-4"
})(["min-height:revert;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){min-height:164px;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const TwoColItemWrapper = styled(Box).withConfig({
  displayName: "FeatureCopyGrid__TwoColItemWrapper",
  componentId: "sc-mtaumj-5"
})(["min-height:revert;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){min-height:84px;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));

/**
 *
 * Feature copy blocks describe product
 * features in a grid
 */
const FeatureCopyGrid = ({
  children,
  variant
}) => {
  console.warn('FeatureCopyGrid is deprecated. Use the v1.1 Getting Started screen instead. See: https://www.fuegokit.design/react-storybook/?path=/story/patterns-getting-started-page--getting-started-page-growth');
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      px: 4
    }
  }, /*#__PURE__*/React.createElement(GridWrapper, null, variant === 'threeColumn' ? /*#__PURE__*/React.createElement(ThreeColumnGrid, {
    as: "dl"
  }, children) : variant === 'twoByTwo' ? /*#__PURE__*/React.createElement(TwoByTwoGrid, {
    as: "dl"
  }, children) : variant === 'fourColumn' ? /*#__PURE__*/React.createElement(FourColumnGrid, {
    as: "dl"
  }, children) : null));
};
FeatureCopyGrid.displayName = "FeatureCopyGrid";
const GridWrapper = styled(Box).withConfig({
  displayName: "FeatureCopyGrid__GridWrapper",
  componentId: "sc-mtaumj-6"
})(["margin:0 auto;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const FourColumnGrid = styled(Box).withConfig({
  displayName: "FeatureCopyGrid__FourColumnGrid",
  componentId: "sc-mtaumj-7"
})(["display:flex;flex-direction:column;& > * + *{margin-block-start:", ";}@media (min-width:350px){}@media (min-width:", "){display:grid;grid-template-columns:repeat(2,minmax(0,1fr));& > * + *{margin-block-start:0;}}@media (min-width:", "){}@media (min-width:", "){display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:", ";}"], get('space.5'), get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'), get('space.4'));
const ThreeColumnGrid = styled(Box).withConfig({
  displayName: "FeatureCopyGrid__ThreeColumnGrid",
  componentId: "sc-mtaumj-8"
})(["display:flex;flex-direction:column;margin-bottom:", ";gap:", ";@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){display:grid;grid-template-columns:repeat(3,1fr);justify-items:center;}@media (min-width:", "){}"], get('space.5'), get('space.5'), get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const TwoByTwoGrid = styled(Box).withConfig({
  displayName: "FeatureCopyGrid__TwoByTwoGrid",
  componentId: "sc-mtaumj-9"
})(["display:flex;flex-direction:column;& > * + *{margin-block-start:", ";}@media (min-width:350px){}@media (min-width:", "){display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:", ";& > * + *{margin-block-start:0;}}@media (min-width:", "){}@media (min-width:", "){}"], get('space.5'), get('breakpoints.0'), get('space.4'), get('breakpoints.1'), get('breakpoints.2'));

// --------------------------------------------------------
// Exports
FeatureCopyGrid.displayName = 'FeatureCopyGrid';
FeatureCopyBlock.displayName = 'FeatureCopyBlock';
var FeatureCopyGrid$1 = Object.assign(FeatureCopyGrid, {
  Item: FeatureCopyBlock
});

export { FeatureCopyBlock, FeatureCopyGrid$1 as default };
